export default __webpack_public_path__ + "static/ponderbank-logo-67d7b3a0602584a23e428d69fa4f66ee.png";